<template>
  <div class="section center-vertical">
    <div class="section-horizontal border-radiuss mt-5 mb-5">
      <div class="horizontal-content">
        <div class="horizontal horizontal-1">
          <div class="titulo text-center">Estatísticas da Tortura</div>

          <div class="text text-center">
            De acordo com dados das Defensoria Públicas do Rio de Janeiro e São
            Paulo da Conectas Direitos Humanos, de 2017, divulgados pelo le
            monde diplomatique, as
          </div>
          <div class="titulo small text-center">vítimas de tortura no RJ</div>
          <div class="d-flex row-g justify-content-center">
            <div class="data">
              <span
                ><NumberCounter :from="0" :to="80" :duration="1"></NumberCounter
                >%</span
              >
              <span class="complemento">negros</span>
            </div>
            <div class="data">
              <span
                ><NumberCounter :from="0" :to="20" :duration="1"></NumberCounter
                >%</span
              >
              <span class="complemento">brancos</span>
            </div>
          </div>
          <div class="text text-center mt-3">
            Negros foram 67% dos denunciantes, enquanto brancos 32%, de acordo
            com levantamento.
          </div>
          <div class="d-flex row-g justify-content-center">
            <div class="data">
              <span
                ><NumberCounter :from="0" :to="67" :duration="1"></NumberCounter
                >%</span
              >
            </div>
            <div class="data">
              <span
                ><NumberCounter :from="0" :to="32" :duration="1"></NumberCounter
                >%</span
              >
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-2">
            <a
              class="link-fonte text-center"
              href="https://diplomatique.org.br/decisao-do-cnj-torna-tortura-invisivel-e-indetectavel/"
              target="_blank"
              ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.text-red {
  margin-top: 60px;
  background-color: #d01c1f;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}

.border-radiuss {
  border-radius: 20px !important;
}

.row-g {
  column-gap: 30px;
}

.horizontal-content {
  color: #d01c1f;
  font-size: 1.1rem;
  font-family: Roboto Condensed;
  font-weight: 300;
  padding: 30px;
  display: flex;
  width: fit-content;
}

.seta {
  color: #626262;
}

.complemento {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.1rem;
  position: relative;
  top: -10px;
}

.line {
  width: 1px;
  background-color: #6262625b;
  height: 540px;
  margin: 0 55px;

  &.none {
    background-color: transparent;
    margin: 0 30px 0 15px;
  }
}

.horizontal {
  position: relative;
  overflow-y: auto;
  width: 100%;

  .data {
    font-size: 3rem;
    font-family: Roboto Mono;
    font-weight: 100;
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }

  .titulo {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: 300;
    font-size: 2rem;
    line-height: 1.7rem;
    color: #d01c1f;
    margin-bottom: 30px;
    width: 100%;

    &.small {
      font-size: 1.4rem;
      margin-bottom: 0px;
    }
  }
  .text {
    width: 100%;
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: 300;
    font-size: 1rem;
    line-height: 1.1rem;
    text-align: justify;
    color: #000000;
    margin-bottom: 30px;
    max-height: 400px;

    padding-right: 2px;

    b {
      color: #d01c1f;
    }

    &.big {
      font-size: 3rem;
      line-height: 3.1rem;
      font-family: Roboto Mono;
      color: #626262;
      font-weight: 100;
    }
  }
  img {
    width: 260px;
  }
  .numeracao {
    font-family: Roboto Mono;
    font-weight: 100;
    font-size: 3.3rem;
  }
}

*::-webkit-scrollbar {
  width: 0px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}
</style>